<template>
	<div class="box">
		<div class="his-order-close-timer shop-location-div"
			v-if="orderDetail.status == 0  && getCloseTime(orderDetail.createdTime)>0">
			<van-count-down :time="getCloseTime(orderDetail.createdTime)" format="mm分ss秒后失效" />
		</div>
		<div class="shop-location-div">
			<template v-if="orderDetail.orderType == 1">
				<div class="shop-name">
					<img src="@/assets/shop.png">
					<span>{{orderDetail.storeName}}</span>
				</div>
				<div class="shop-location">
					{{orderDetail.address}}
				</div>
			</template>
			<template v-else>
				<div class="shop-name">
					<img src="@/assets/shop.png">
					<span>星巴克中杯通兑券</span>
				</div>
			</template>
		</div>
		<div class="pay-goods-div" v-if="orderDetail.orderType == 1">
			<van-row v-for="(item,index) in orderDetail.starSubOrders" :key="index">
				<van-col span="8">
					<img class="pay-goods-image" :src="item.thumb" />
				</van-col>
				<van-col span="12">
					<div class="pay-goods-name">{{item.foodName}}</div>
					<div class="pay-goods-specification">{{item.specification}}</div>
					<div class="pay-goods-price">
						<span>¥</span>
						<span>{{parseFloat(item.foodPrice).toFixed(2) }}</span>
					</div>
				</van-col>
				<van-col span="4">
					<div class="pay-goods-count">x{{item.goodsNum}}</div>
				</van-col>
			</van-row>
			<div class="divider-div"></div>
			<van-row type="flex" justify="space-between">
				<van-col span="8">
					<div class="pay-save-money">
						已省：¥{{parseFloat(orderDetail.officialTotalAmount - orderDetail.totalAmount).toFixed(2)}}</div>
				</van-col>
				<van-col span="16">
					<div class="pay-money">
						<span>共一件，实付：</span>
						<span>¥</span>
						<span>{{parseFloat(orderDetail.totalAmount+'').toFixed(2) }}</span>
						<span>¥{{orderDetail.officialTotalAmount}}</span>
					</div>
				</van-col>
			</van-row>
		</div>
		<div class="pay-goods-div" v-else>
			<van-row>
				<van-col span="8">
					<img class="pay-goods-image" src="@/assets/xingbake.png" />
				</van-col>
				<van-col span="12">
					<div class="pay-goods-name">星巴克中杯通兑券</div>
					<div class="pay-goods-specification"></div>
					<div class="pay-goods-price">
						<span>¥</span>
						<span>{{parseFloat(orderDetail.totalAmount+'').toFixed(2)}}</span>
					</div>
				</van-col>
				<van-col span="4">
					<div class="pay-goods-count">x{{1}}</div>
				</van-col>
			</van-row>
			<div class="divider-div"></div>
			<van-row type="flex" justify="space-between">
				<van-col span="8">
				</van-col>
				<van-col span="16">
					<div class="pay-money">
						<span>共一件，实付：</span>
						<span>¥</span>
						<span>{{parseFloat(orderDetail.totalAmount+'').toFixed(2) }}</span>
					</div>
				</van-col>
			</van-row>
		</div>
		<user-amount></user-amount>
		<PayCoupon :isNotSelect="refrash"></PayCoupon>
		<div class="pay-phone-detail-div">
			<div class="pay-phone-cell-div">
				<van-field v-model="orderDetail.phone"
					:disabled="orderDetail.phone!=null && orderDetail.phone.length == 11" type="digit" label="文本"
					input-align="right" placeholder="请输入手机号" maxlength="11">
					<template #label>
						<div class="pay-phone-div">
							<div>联系电话</div>
						</div>
					</template>
				</van-field>
			</div>
		</div>
		<div class="pay-money-div">
			<van-row type="flex" justify="space-between">
				<van-col span="14">
					<div class="pay-money-detail">
						<span>合计：¥</span>
						<span>{{parseFloat(orderPayPrice).toFixed(2)}}</span>
					</div>
				</van-col>
				<van-col span="10">
					<div class="pay-btn">
						<van-button round :color="this.$enum.CONSTANT.APP_THEME_COLOR" @click="openPayType()">确认支付
						</van-button>
					</div>
				</van-col>
			</van-row>
		</div>


		<van-action-sheet v-model="showPayType" :round="false" :closeable="false" :overlay="htmlShowPayType">
			<PayType :orderId="orderId" :payedPrice="orderPayPrice"  ref="payTypeRef"  v-show="htmlShowPayType" :code="code" @success="doSuccess" @loadCode="loadNowCode()">
			</PayType>
		</van-action-sheet>
	</div>
</template>

<script>
	import {
		getOrderById
	} from '@/request/api';
	import PayCoupon from '@/components/pay/PayCoupon.vue'
	import PayType from '@/components/pay/PayType.vue'
	import PhoneCode from '@/components/pay/PhoneCode.vue'
	import {
		mapState,
		mapGetters,
		mapMutations,
		mapActions
	} from "vuex";
	import {

		CountDown,
		Col,
		Row,
		Button,
		ActionSheet,
		Field


	} from 'vant';
import UserAmount from '../components/pay/UserAmount.vue';
	export default {
		name: 'orderDetail',
		computed: {
			...mapGetters(["sOrderId", "sCouponObj",'sActual']),
			// 计算价格换成接口计算
			orderPayPrice() {
				let price =this.orderPrice
				if(this.sCouponObj && this.sCouponObj.length>0){
					// console.log(this.sActual,price);
					price -= parseFloat(this.sActual)
				}
				if(price<0){
					return this.orderPrice
				}
				// if (this.sCouponObj) {
				// 	price = price - parseFloat(this.sCouponObj.discountAmount) > 0 ? price - parseFloat(this.sCouponObj
				// 		.discountAmount) : 0;
				// }
				return price;
			}
		},
		components: {
			[CountDown.name]: CountDown,
			[Col.name]: Col,
			[Row.name]: Row,
			[PayCoupon.name]: PayCoupon,
			[UserAmount.name]: UserAmount,
			[Button.name]: Button,
			[ActionSheet.name]: ActionSheet,
			[PayType.name]: PayType,
			[Field.name]: Field,
			// [ComShopLocation.name]: ComShopLocation,
			// [OrderGoods.name]: OrderGoods,
			// [ComTabbar.name]: ComTabbar,

		},
		created() {
			// let browserFlag = this.isWechat()
			// if (browserFlag == 0) {
			// 	let code = this.$getUrlParam("code")
			// 	if (!code && !this.sOrderCode) {
			// 		this.getCode()
			// 	} else {
			// 		if (code) {
			// 			this.setOrderCode(code)
			// 			this.code = code;
			// 			// let uri =  window.location.href
			// 			// uri = uri.split("?")[0]+'#/home'
			// 			// window.location.replace(uri)
			// 		} else {
			// 			this.code = this.sOrderCode
			// 			this.setOrderCode('')
			// 		}
			// 	}
			// }
			this.pollGetOrder()
		},
		data() {
			return {
				orderDetail: {

				},
				orderTimer: '',
				orderId: '',
				htmlShowPayType:true,
				orderPrice: null,
				showPayType: false,
				orderPriced:null,
				code: '',
				refrash:false
			}
		},
		methods: {
			// 新增 setGoodsList 用于存放订单里的商品列表
			...mapMutations(['setOrderId', 'setOrderCode','sSetCouponId','setGoodsList']),
			openPayType() {
				if(this.orderPayPrice == 0){
					this.htmlShowPayType = false;
				}else{
					this.htmlShowPayType = true;
				}
				this.showPayType = true;
				this.setOrderId(this.orderId);
				this.$nextTick(()=>{
					if(this.orderPayPrice == 0){
						this.$refs.payTypeRef.payType = '2';
						this.$refs.payTypeRef.createOrder();
					}else{
						this.$refs.payTypeRef.payType = '0';
					}
				})
			},
			doSuccess() {
				if (this.orderId) {
					this.setOrderId(this.orderId);
					this.$router.push({
						name: 'orderDetail',
						params: {
							orderId: this.orderId
						}
					})
				}
				// this.$router.replace({
				// 	name: 'historyOrder'
				// })
				// this.$emit('loadCode')
			},
			isWechat() {
				var ua = window.navigator.userAgent.toLowerCase();
				if (ua.match(/MicroMessenger/i) == "micromessenger") {
					return 0
				} else {
					return 1
				}
			},
			loadNowCode() {
				let browserFlag = this.isWechat()
				if (browserFlag == 0) {
					let code = this.$getUrlParam("code")
					if (!code && !this.sOrderCode) {
						this.getCode()
					} else {
						if (code) {
							this.setOrderCode(code)
							this.code = code;
							let uri = window.location.href
							uri = uri.split("?")[0] + '#/historyOrder'
							window.location.replace(uri)
						} else {
							this.code = this.sOrderCode
							this.setOrderCode('')
						}
					}
				}
			},
			getUrlParam(name) {
				var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
				let url = window.location.href.split('#')[0]
				let search = url.split('?')[1]
				if (search) {
					var r = search.substr(0).match(reg)
					if (r !== null) return unescape(r[2])
					return null
				} else {
					return null
				}
			},
			getCode() {
				let payBack = window.location.href;
				let appId = "wx3de49bcab72a4020"
				// 测试环境
				// let appId = "wxeade3e34841010b2"
				let codeUri = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appId + "&redirect_uri=" +
					encodeURIComponent(payBack) + "&response_type=code&scope=snsapi_base#wechat_redirect"
				window.location.href = codeUri
			},
			getCloseTime(createdTime) {
				let now = new Date().getTime();
				createdTime = new Date(Date.parse(createdTime.replace(/-/g, "/"))).getTime();
				return 10 * 60 * 1000 - (now - createdTime)
			},

			pollGetOrder() {
				let orderId = this.$route.query.orderId;
				this.orderId = orderId;
				this.getOrder();
				// if( this.orderDetail.orderType == 1){
				// 	this.orderTimer = setInterval(this.pollTimer, 3000);
				// }
			},
			getOrder() {
				// console.log(this.orderId)
				let cardIdList =[]
				getOrderById({
					id: this.orderId
				}).then(res => {
					res.starSubOrders.forEach(childItem => {
						childItem.goodsId = childItem.foodId;
						childItem.goodsName = childItem.foodName;
						childItem.goodsNum = childItem.foodNum;
						childItem.goodsSpec = childItem.specification;
						childItem.thumb = childItem.thumb;
						childItem.goodsEndPrice = childItem.foodEndPrice;
					})
					// console.log(res);
					// 将该订单内选择的卡券进行保存
					cardIdList = res.userCardIdList?res.userCardIdList.split(','):[]
					if(cardIdList.length!=0){
						cardIdList.forEach(id=>{
							this.sSetCouponId(id)
						})
					}else{
						this.sSetCouponId(res.userCardId)
					}
					this.orderDetail = res;
					this.orderPrice = res.totalAmount;
					// 添加 商品列表到store里
					// this.setGoodsList(res.starSubOrders)
					// 可对卡券进行再选择 锁定
					this.refrash = true
					// 需要 返回 使用的卡券ID user_card_id_list
					
				})
			},
			//定时器-订单相关
			pollTimer() {
				if (this.orderDetail.status >= 3) {
					this.stopOrderTimer();
				} else {
					this.getOrder(this.orderId);
				}
			},
			stopOrderTimer() {
				clearInterval(this.orderTimer);
			}



		}
	}
</script>

<style scoped>
	.box {
		width: 100%;
		min-height: 100%;
		background-color: #f5f5f5;
		padding: 10px;
	}

	.shop-detail-div,
	.shop-pay-goods-div {
		margin-top: 10px;

	}

	.emtry-div {
		width: 100%;
		height: 70px;
	}

	.his-order-close-timer {
		padding: 0 8px;
	}


	.shop-location-div {
		width: 100%;
		padding: 10px 18px;
		background-color: #ffffff;
	}

	.shop-location-div>.shop-name>span {
		font-size: 17px;
		line-height: 17px;
		font-weight: 600;
		color: #363636;
		margin-left: 6px;
	}

	.shop-location-div>.shop-name>img {
		width: 15px;
		height: 15px;
	}

	.shop-location-div>.shop-location {
		font-size: 12px;
		line-height: 15px;
		width: 80%;
		color: #6b6b6b;

	}

	.shop-location-div .shop-name {
		display: inline-flex;
		align-items: center;
		padding-bottom: 5px;
	}


	.pay-goods-div {
		border-radius: 5px;
		padding: 10px;
		background-color: #ffffff;
		margin-top: 10px;
	}


	.pay-goods-image {
		width: 90px;
		height: 90px;
		display: block;
		margin: 0 auto;
	}

	.pay-goods-name {
		padding-bottom: 5px;
		color: #343434;
		font-size: 17px;
		font-weight: 650;
	}

	.pay-goods-specification {
		padding-bottom: 3px;
		color: #656565;
		font: 14px;
	}

	.pay-goods-price>span:first-child {
		color: #c8544a;
		font-size: 14px;
		font-weight: 570;
	}

	.pay-goods-price>span:last-child {
		color: #c8544a;
		font-size: 16px;
		font-weight: 570;
	}

	.divider-div {
		width: 100%;
		height: 1px;
		border-top: #dedede 1px dashed;
		padding: 5px;
	}

	.pay-goods-count {
		font-size: 15px;
		color: #343434;
		text-align: center;
		padding-top: 30px;
		font-weight: 600;

	}

	.pay-save-money {
		font-size: 15px;
		color: #414141;
		font-weight: 500;
		padding-left: 5px;
	}

	.pay-money {
		padding-right: 5px;
		text-align: right;
	}

	.pay-money>span:nth-child(1) {
		font-size: 15px;
		color: #414141;
		font-weight: 500;
	}

	.pay-money>span:nth-child(2) {
		font-size: 13px;
		color: #cf4645;
		font-weight: 550;

	}

	.pay-money>span:nth-child(3) {
		font-size: 16px;
		color: #cf4645;
		font-weight: 550;

	}

	.pay-money>span:nth-child(4) {
		font-size: 13px;
		color: #959394;
		text-decoration: line-through;
		margin-left: 3px;
	}


	.pay-money-div {
		padding: 15px;
		width: 100%;
		height: auto;
		position: fixed;
		bottom: 0px;
		left: 0px;
		border-top:0; 
		/* 原 border-top:; */
		background-color: #ffffff;
		box-shadow: 0 2px 10px #c5c5c5;
		border-top-color: #c5c5c5;
	}

	.pay-money-detail>span:first-child {
		font-size: 15px;
		font-weight: 550;
		color: #2d2d2d;
	}

	.pay-money-detail>span:last-child {
		font-size: 22px;
		font-weight: 550;
		color: #2d2d2d;
	}

	.pay-btn {
		text-align: right;
	}

	.pay-btn .van-button {
		width: auto;
		height: auto;
		padding: 6px 10px;
		margin: 0;
		font-size: 15px;
	}

	.pay-phone-detail-div {
		padding-top: 15px;
	}

	.pay-phone-cell-div {
		padding: 10px 0;
		background: #fff;
	}

	.pay-phone-div {
		color: #333;
	}
</style>
